export enum GetBillingPlanEnum {
  TRIAL = 1,
  ADVANCE = 2,
  EXPIRY = 3,
  BETA = 4,
}
export interface GetBillingResponseType {
  plan: GetBillingPlanEnum;
  startedAt?: string;
  endedAt?: string;
  period?: number;
  amount?: number;
  subscribed?: boolean;
  cancelledAt?: string;
  country: string;
  /** 前端專用：API 失敗時 useGetBilling 回傳的預設值會帶此旗標，代表「方案狀態不明」而非真的已到期 */
  isFallback?: boolean;
  /** 續扣失敗緩衝期（plan=TRIAL）且重試中：顯示「進階方案（付款重試中）」用 */
  paymentRetrying?: boolean;
  /** 續扣失敗且重試耗盡/永久失敗：只能靠更新付款方式救回，顯示「進階方案（付款失敗）」用 */
  paymentRetryStopped?: boolean;
  /** 續扣重試成功、已付費但尚未生效的下期進階方案（錨在緩衝列結束） */
  pendingAdvanced?: {
    startedAt: string;
    endedAt: string;
    period: number;
    amount: number;
  };
}
